import { FC, useState } from 'react'
import { TTheme, useCustomTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import InfoIcon from '@/assets/images/info-icon.svg?react'
import ArrowUpIcon from '@/assets/images/arrow-up.svg?react'
import ArrowDownIcon from '@/assets/images/arrow-down.svg?react'
import {
    CardBody,
    CardBodyContent,
    CardHeader,
    CardWrapper,
    RuleNameGroup,
    RuleTitle,
    ToggleButton,
} from './ExpandableRuleCard.styles'
import { ExpandableRuleCardProps } from './ExpandableRuleCard.types'

const ExpandableRuleCard: FC<ExpandableRuleCardProps> = ({
    ruleName,
    defaultExpanded = false,
    dataTestId = 'expandable-rule-card',
    children,
}) => {
    const theme = useCustomTheme() as TTheme
    const [isExpanded, setIsExpanded] = useState(defaultExpanded)

    return (
        <CardWrapper data-testid={dataTestId}>
            <CardHeader>
                <RuleTitle>
                    <InfoIcon
                        width={16}
                        height={16}
                        color={theme.colors.semantic.collapsingBannerIcon}
                    />
                    <RuleNameGroup>
                        <Typography
                            variant="xs-semibold"
                            color={theme.colors.greys[800]}
                        >
                            Rule Name:
                        </Typography>
                        <Typography
                            variant="xs-semibold"
                            color={theme.colors.greys[800]}
                            noWrap={false}
                            testId={`${dataTestId}-rule-name`}
                        >
                            {ruleName}
                        </Typography>
                    </RuleNameGroup>
                </RuleTitle>
                <ToggleButton
                    type="button"
                    onClick={() => setIsExpanded((expanded) => !expanded)}
                    data-testid={`${dataTestId}-toggle`}
                >
                    <Typography variant="xs-semibold" color="inherit">
                        {isExpanded ? 'Show less' : 'Show more'}
                    </Typography>
                    {isExpanded ? (
                        <ArrowUpIcon
                            width={16}
                            height={16}
                            data-testid={`${dataTestId}-toggle-collapse`}
                        />
                    ) : (
                        <ArrowDownIcon
                            width={16}
                            height={16}
                            data-testid={`${dataTestId}-toggle-expand`}
                        />
                    )}
                </ToggleButton>
            </CardHeader>
            <CardBody
                isExpanded={isExpanded}
                aria-hidden={!isExpanded}
                data-testid={`${dataTestId}-body`}
            >
                <CardBodyContent>{children}</CardBodyContent>
            </CardBody>
        </CardWrapper>
    )
}

export default ExpandableRuleCard
